export default __webpack_public_path__ + "static/media/yay.bceceb7c.webp";